(function (Drupal, $) {

  // Use strict mode.
  'use strict';

  /**
   * Declare basic scripts behavior.
   *
   * @type {{attach: Drupal.basic.attach}}
   */
  Drupal.behaviors.basic = {
    attach: function (context, settings) {
      // Add 'hide' class to all elements with 'collapsed' class.
      $('.collapsed:not(.accordion-button)').addClass('hide').hide();

      // Get all elements with iframe-embed data.
      $('[data-iframe-embed]').click(function (e) {
        // Remove any other actions.
        e.preventDefault();

        // Get current object.
        const $that = $(this);

        // Get current url for iframe.
        let url = $that.data('iframe-embed');

        // check if we have some url.
        if (url !== '') {
          // If so, add autoplay and other options.
          url += "?autoplay=1&title=0&badge=0&byline=0&portrait=0";

          // Remove the data attribute.
          $that.data('iframe-embed', '');

          // Create the iframe.
          const $iframe = $('<div class="responsive-embed"></div>').hide();

          // Get the parent of the current object.
          const $p = $that.parents('.page-wrapper').find('.'+$that.data('prepend')).first();

          // Calculate the offset.
          const y = $p.offset().top - 30;

          // Add the iframe to the parent.
          $p.prepend($iframe);

          // Update the iframe with the new url.
          $iframe.html('<iframe seamless allowfullscreen frameborder="0" src="'+url+'" />');
          $iframe.slideDown(333);

          // Scroll to the iframe.
          $('html, body').animate({
            scrollTop: y
          }, 333);
        }
      });

      // Get all elements with data-collapse.
      $('[data-collapse]').click(function (e) {
        // Remove any other actions.
        e.preventDefault();

        // Get current object.
        var $that = $(this);

        // Get data from current object.
        const data = $that.data('collapse');

        // Get element with data-collapse.
        const $element = $(data);

        // Add fade animation.
        $that.fadeTo(333, 0);

        // Remove any hide classes and slide it down.
        $element.removeClass('hide').slideDown(333, () => {});
      });

      // Get all quick links or ui-hover-btn elements.
      $('.quick-links, .ui-hover-btn').on('mouseenter mouseleave touchstart', function (e) {
        // Check the event type.
        if (e.type === 'touchstart') {
          // Trigger click event.
          $(this).off('mouseenter mouseleave');

          // Get a target element.
          const $that = $(e.target);

          // Check if we have an anchor tag.
          if ($that.prop('tagName') !== 'A') {
            // If so, toggle active class.
            $(this).toggleClass("active");
          }
          else {
            // In any other case, add active class.
            $(this).addClass("active");
          }
        } else {
          // Toggle active class.
          $(this).toggleClass("active");
        }
      });

      // Get mobile nav for footer.
      $('#site-header .mobile-nav').click(function() {
        // Toggle active class.
        $('#site-header').toggleClass('active');
      });

      // Add bottoming to cfgFlyout.
      $("#cfgFlyout").stick_in_parent({
        bottoming: true
      });

      once('tv-tabs', '.field--tv-tabs').forEach(function (element) {
        let container = element;
        $('.nav-link', container).on('show.bs.tab', function(e) {
          let $title = $(e.currentTarget);
          $('.tv-tabs-nav-mobile', container).children().html($title.html());
          $('.tv-tabs-nav-mobile', container).removeClass('showed').next('.tv-tabs-nav').addClass('d-none');
        });
      });

      once('tv-tabs-mobile', '.tv-tabs-nav-mobile').forEach(function (element) {
        var $this = $(element);
        $this.on('click', function (event) {
          event.preventDefault();

          $(this).toggleClass('showed').next('.tv-tabs-nav').toggleClass('d-none');
        });
      });
    }
  };

  /**
   * Scripts for sticky bar.
   *
   * @type {{attach: Drupal.sticky_bar.attach}}
   */
  Drupal.behaviors.sticky_bar = {
    attach: function (context, settings) {
      // Create sticky variables.
      let stickyY, stickyH;

      // Get first sticky bar.
      $('.sticky-bar').first().each(function() {
        // Get current object.
        const $that = $(this);

        // Calculate the Y and H variables.
        stickyY = Math.floor($that.offset().top);
        stickyH = $that.height() + 0;

        // Add has-js class.
        $that.addClass('has-js');

        // Add footerFixed variable.
        let footerFixed = false;

        // Get sticky trigger object.
        const $trigger = $('.sticky-trigger');

        // Check if we have a trigger.
        if ($trigger[0]) {
          // Get the offset.
          stickyY = $trigger.offset().top;
        }

        // Check if we are below the window height.
        if (stickyY < $(window).height()) {
          // Mark it as fixed.
          footerFixed = true;

          // Add fixed class.
          $that.addClass('fixed');
        }

        // Add resize event.
        $(window).resize(function () {
          // Check if we have trigger.
          if ($trigger[0]) {
            // Get the offset.
            stickyY = $trigger.offset().top;
          }
          else {
            // Get the parent.
            const $parent = $that.parents('.paragraph');

            // Check if we have a parent.
            if ($parent[0]) {
              // Get the offset of a parent.
              stickyY = $parent.next().offset().top;
            }
            else {
              // Get the offset.
              stickyY = $that.next().offset().top;
            }
          }
        });

        // Add scroll event.
        $(window).scroll(function () {
          // Calculate the offset.
          const y = $(this).scrollTop() + $(this).height();

          // Check offset data.
          if (y <= stickyY) {
            // Check if we have footer fixed.
            if (footerFixed) {
              // If so, mark it as false.
              footerFixed = false;

              // And remove fixed class.
              $that.removeClass('fixed');
            }
          }
          else {
            // Check if we have footer fixed.
            if (!footerFixed) {
              // If not, mark it as true.
              footerFixed = true;

              // And add fixed class.
              $that.addClass('fixed');
            }
          }
        });
      });
    }
  };

} (Drupal, jQuery));
